import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreFacilities from './StoreFacilities.js';

const StoreFacilitiesContainer = (_param)=>{
    var { facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "facilities"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.facilities.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(StoreFacilities, swcHelpers.extends({
        labels: labels,
        facilities: facilities
    }, rest));
};

export { StoreFacilitiesContainer as default };
//# sourceMappingURL=StoreFacilitiesContainer.js.map
